module.exports = __webpack_public_path__ + "img/万利威德.6ce66694.png";